<template>
  <b-container class="mt-4">
    <b-card>
      <b-col cols="6">
        <h3 class="mb-0">Nueva Venta</h3>
      </b-col>
      <hr />
      <b-row>
        <b-col cols="5">
          <!-- Input para escanear o escribir código -->
          <b-form-group label="Código de barras / artículo">
            <b-input-group>
              <b-form-input
                v-model="barcode"
                autofocus
                placeholder="Escanear o escribir código..."
                @keyup.enter="buscarArticuloPorCodigo"
                :disabled="loading"
                size="sm"
              ></b-form-input>
              <b-input-group-append>
                <!--b-button
                  variant="primary"
                  @click="buscarArticuloPorCodigo"
                  :disabled="loading"
                >
                  Buscar
                </b-button-->
              </b-input-group-append>
              <b-button
                class="ml-3"
                variant="outline-info"
                @click="openSearchModal"
                size="sm"
                :disabled="loading"
              >
                <b-icon icon="search"></b-icon>
              </b-button>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label="Cantidad">
            <b-input-group>
              <b-form-input
                v-model="quantity"
                placeholder="0"
                size="sm"
                :disabled="loading"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="2"></b-col>
        <b-col cols="3">
          <b-form-group label="Fecha">
            <b-input-group>
              <b-form-datepicker
                id="date"
                v-model="date"
                size="sm"
                :value-as-date="true"
                :date-format-options="{
                  day: '2-digit',
                  month: '2-digit',
                  year: '2-digit',
                }"
                locale="es"
              ></b-form-datepicker>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Artículo seleccionado -->
      <!--div v-if="articuloSeleccionado" class="border rounded p-3 mb-3">
        <h5 class="mb-2">{{ articuloSeleccionado.description }}</h5>
        <p class="mb-1 text-muted">
          Precio: ${{ Number(articuloSeleccionado.price).toFixed(2) }}
        </p>

        <b-form-group label="Cantidad">
          <b-form-input
            type="number"
            min="1"
            v-model.number="cantidad"
            @keyup.enter="agregarLineaVenta"
          ></b-form-input>
        </b-form-group>

        <b-button variant="success" @click="agregarLineaVenta">
          Agregar
        </b-button>
      </div-->

      <!-- Tabla de líneas de venta -->
      <div style="min-height: 300px; max-height: 400px; overflow-y: auto">
        <b-table
          :items="lines"
          :fields="fields"
          striped
          bordered
          small
          responsive
          class="mt-4"
        >
          <template #cell(total)="data">
            ${{ Number(data.item.price * data.item.quantity).toFixed(2) }}
          </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              variant="danger"
              @click="eliminarLinea(data.index)"
            >
              <b-icon icon="trash" />
            </b-button>
          </template>
          <template #cell(quantity)="data">
            <div class="d-flex align-items-center">
              <b-button
                size="sm"
                variant="outline-secondary"
                @click="updateQuantity(data.index, -1)"
              >
                -
              </b-button>

              <b-form-input
                type="number"
                min="0"
                class="mx-2 text-center"
                style="width: 70px"
                v-model.number="data.item.quantity"
              ></b-form-input>

              <b-button
                size="sm"
                variant="outline-secondary"
                @click="updateQuantity(data.index, +1)"
              >
                +
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <hr />
      <!-- Total -->
      <div class="text-right mt-3">
        <h5>Total: ${{ total.toFixed(2) }}</h5>
      </div>
      <!-- Botón finalizar -->
      <div class="text-right mt-3">
        <b-button
          variant="primary"
          :disabled="lines.length === 0 || loading"
          @click="finalizarVenta"
        >
          <b-spinner small v-if="loading" label="Guardando..." class="mr-2" />
          Finalizar venta
        </b-button>
      </div>
    </b-card>
    <!-- Modal buscador de artículos -->
    <b-modal
      id="modal-search"
      ref="modalSearch"
      title="Buscar artículo"
      hide-footer
      size="lg"
    >
      <b-overlay
        :show="loadingModal"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form-group>
          <b-input-group>
            <b-form-input
              autofocus
              v-model="search"
              placeholder="Buscar por nombre, descripción o código..."
              @keyup.enter="buscarArticulos"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" @click="buscarArticulos">
                Buscar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <div style="max-height: 400px; overflow-y: auto">
          <b-table
            :items="searchResult"
            :fields="searchFields"
            small
            hover
            striped
            responsive
            @row-clicked="seleccionarArticulo"
          >
            <template #cell(image)="data">
              <a
                v-if="data.item.files.length"
                :href="getImageUrl(data.item.files[0].url)"
                target="_blank"
                rel="noopener noreferrer"
              >
                <b-img
                  :src="getImageUrl(data.item.files[0].url)"
                  thumbnail
                  fluid
                  alt="Imagen"
                  style="
                    width: 60px;
                    height: 60px;
                    object-fit: cover;
                    cursor: pointer;
                  "
                ></b-img>
              </a>
              <b-img
                v-else
                src="https://api.luanva.elio.ar/storage/articulos/images/no-image.png"
                thumbnail
                fluid
                alt="Sin imagen"
                style="width: 60px; height: 60px; object-fit: cover"
              ></b-img>
            </template>
            <template #cell(price)="data">
              ${{ Number(data.item.price).toFixed(2) }}
            </template>
          </b-table>
        </div>
      </b-overlay>
    </b-modal>
  </b-container>
</template>

<script>
import ArticleService from "@/services/article.service";
import VentaService from "@/services/venta.service";

export default {
  data() {
    return {
      //por defecto tiene la fecha actual
      date: new Date().toISOString().substr(0, 10),
      barcode: "",
      quantity: 1,
      articuloSeleccionado: null,
      cantidad: 1,
      lines: [],
      fields: [
        { key: "description", label: "Descripción" },
        { key: "price", label: "Precio" },
        { key: "quantity", label: "Cantidad" },
        { key: "total", label: "Total" },
        { key: "actions", label: "" },
      ],
      search: "",
      searchResult: [],
      searchFields: [
        { key: "image", label: "Imagen" },

        { key: "code", label: "Código" },
        { key: "description", label: "Descripción" },
        { key: "price", label: "Precio" },
      ],
      loading: false,
      loadingModal: false,
    };
  },
  computed: {
    total() {
      return this.lines.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
  },
  methods: {
    updateQuantity(index, delta) {
      const newValue = (this.lines[index].quantity || 0) + delta;

      // prevent negative values
      this.$set(this.lines[index], "quantity", Math.max(newValue, 0));
    },
    getImageUrl(path) {
      if (!path)
        return "https://api.luanva.elio.ar/images/no-image.png";
      // Si ya tiene http, no lo toques
      if (path.startsWith("http")) return path;
      // Caso normal: prepend dominio
      return `https://api.luanva.elio.ar${path}`;
    },
    async buscarArticuloPorCodigo() {
      if (!this.barcode.trim()) return;
      this.loading = true;
      try {
        const res = await ArticleService.findByCode(this.barcode.trim());
        this.articuloSeleccionado = res.data;
        this.agregarLineaVenta();
      } catch (err) {
        this.$bvToast.toast("Artículo no encontrado", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
    openSearchModal() {
      this.search = "";
      this.searchResult = [];
      this.$refs.modalSearch.show();
    },
    async buscarArticulos() {
      if (!this.search.trim()) return;
      this.loadingModal = true;
      try {
        const res = await ArticleService.search(this.search.trim());
        this.searchResult = res.data;
      } catch (err) {
        this.$bvToast.toast("Error al buscar artículos", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.loadingModal = false;
      }
    },
    seleccionarArticulo(articulo) {
      this.articuloSeleccionado = articulo;
      this.agregarLineaVenta();
      this.$refs.modalSearch.hide();
    },
    agregarLineaVenta() {
      if (!this.articuloSeleccionado) return;
      const existente = this.lines.find(
        (l) => l.id === this.articuloSeleccionado.id
      );
      if (existente) {
        existente.quantity = Number(existente.quantity) + Number(this.quantity);
      } else {
        this.lines.push({
          id: this.articuloSeleccionado.id,
          description: this.articuloSeleccionado.description,
          price: this.articuloSeleccionado.price,
          quantity: this.quantity,
        });
      }
      this.articuloSeleccionado = null;
      this.barcode = "";
      this.quantity = 1;
    },
    eliminarLinea(index) {
      this.lines.splice(index, 1);
    },
    async finalizarVenta() {
      this.loading = true;
      try {
        const payload = {
          items: this.lines.map((l) => ({
            articulo_id: l.id,
            cantidad: l.quantity,
            precio_unitario: l.price,
          })),
          date: this.date,
          total: this.total,
        };
        const res = await VentaService.create(payload);
        this.$bvToast.toast("Venta registrada correctamente", {
          title: "Éxito",
          variant: "success",
          solid: true,
        });
        this.lines = [];
      } catch (err) {
        this.$bvToast.toast("Error al guardar la venta", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
h3 {
  font-weight: 600;
}
</style>

